/*
 * Blue Flesh tiered cart rewards.
 * - Date gate: tiers 2 and 3 (gift + 10%) are hidden by CSS until this script sets
 *   html[data-bf-rewards="active"]. If JS fails, only the free-shipping bar shows.
 * - Gift auto-add: when the promo is active and the eligible subtotal (gift line excluded)
 *   reaches the threshold, add one gift variant (line property _bf_gift=1). Shopify's automatic
 *   discount must make it free; if it does not, the gift line is removed (fail safe).
 * - QA override: ?bf_rewards=active|upcoming (persisted in sessionStorage), ?bf_rewards=reset clears it.
 */
(()=>{
 if(window.BFRewards)return;
 const START=Date.parse('2026-10-22T00:00:00-06:00'); // America/Mexico_City
 const root=window.Shopify?.routes?.root||'/';
 const OWN={'Content-Type':'application/json','X-BF-Rewards':'1'};
 const CART_URL=/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
 const store={
  get(k){try{return sessionStorage.getItem(k)}catch(e){return null}},
  set(k,v){try{sessionStorage.setItem(k,v)}catch(e){}},
  del(k){try{sessionStorage.removeItem(k)}catch(e){}}
 };
 try{
  const q=new URLSearchParams(location.search).get('bf_rewards');
  if(q==='active'||q==='upcoming'){store.set('bf_rewards',q);store.del('bf_gift_blocked')}
  else if(q==='reset'){store.del('bf_rewards');store.del('bf_gift_blocked')}
 }catch(e){}
 const override=()=>{const v=store.get('bf_rewards');return v==='active'||v==='upcoming'?v:null};
 const isActive=()=>{const o=override();return o?o==='active':Date.now()>=START};
 const applyGate=(on)=>document.documentElement.setAttribute('data-bf-rewards',on?'active':'upcoming');
 applyGate(isActive());

 let running=false,rerun=false,timer=0;
 const targets=()=>[document.getElementById('minicart-form'),document.getElementById('bf-cart-page')].filter(Boolean);
 const config=()=>{
  const el=document.querySelector('[data-bf-gift-threshold]');if(!el)return null;
  return{variant:Number(el.dataset.bfGiftVariant)||0,available:el.dataset.bfGiftAvailable==='true',threshold:Number(el.dataset.bfGiftThreshold)||0};
 };
 const isGift=(l)=>!!(l.properties&&l.properties._bf_gift==='1');
 const post=(path,body)=>fetch(root+path,{method:'POST',headers:OWN,body:JSON.stringify(body)}).then(r=>r.json().then(d=>({ok:r.ok&&!d.status&&!d.errors,data:d})));
 const getCart=()=>fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>{if(!r.ok)throw Error('cart');return r.json()});

 async function render(state){
  const list=targets();
  if(list.length){
   const r=await fetch(root+'?section_id=minicart-form',{cache:'no-store'});
   if(r.ok){
    const next=new DOMParser().parseFromString(await r.text(),'text/html').querySelector('#minicart-form');
    if(next)list.forEach(target=>{const sc=target.querySelector('.bf-drawer-scroll')?.scrollTop||0;target.innerHTML=next.innerHTML;const n=target.querySelector('.bf-drawer-scroll');if(n)n.scrollTop=sc})
   }
  }
  document.querySelectorAll('.cart-count').forEach(e=>{e.textContent=e.classList.contains('cart-count-drawer')?'('+state.item_count+')':state.item_count});
  const total=document.querySelector('header-total-price');if(total&&total.updateTotal)total.updateTotal(state);
  const ship=document.querySelector('free-ship-progress-bar');if(ship&&ship.init)ship.init(state.items_subtotal_price);
  document.querySelector('cart-notification')?.cartAction?.();
  document.dispatchEvent(new CustomEvent('bf:cart-priced',{detail:{state,items:state.items,source:'rewards'}}));
 }

 // One reconciliation pass. Returns true when the cart was changed.
 async function pass(){
  const active=isActive();applyGate(active);
  if(!active&&!override())return false;
  const cfg=config();if(!cfg||!cfg.variant||!cfg.threshold)return false;
  let cart=await getCart();
  const giftLines=cart.items.filter(isGift);
  const eligible=cart.items_subtotal_price-giftLines.reduce((t,l)=>t+l.final_line_price,0);
  const blocked=store.get('bf_gift_blocked')==='1';
  const want=active&&cfg.available&&!blocked&&eligible>=cfg.threshold&&cart.item_count>giftLines.reduce((t,l)=>t+l.quantity,0);
  if(!want){
   if(!giftLines.length)return false;
   let res;for(const l of giftLines){res=await post('cart/change.js',{id:l.key,quantity:0})}
   await render(res&&res.ok?res.data:await getCart());return true;
  }
  const present=giftLines.length||cart.items.some(l=>l.variant_id===cfg.variant);
  if(!present){
   const add=await post('cart/add.js',{items:[{id:cfg.variant,quantity:1,properties:{_bf_gift:'1'}}]});
   if(!add.ok){store.set('bf_gift_blocked','1');return false}
   cart=await getCart();
  }
  const line=cart.items.find(isGift);
  // The gift is covered either by a product discount (line at $0) or by the "Regalo…" order discount.
  const orderGift=(cart.cart_level_discount_applications||[]).some(d=>/^regalo/i.test(d.title||'')&&line&&d.total_allocated_amount>=line.final_line_price);
  if(line&&line.final_line_price!==0&&!orderGift){
   // Shopify discount not applied: never charge for the gift.
   store.set('bf_gift_blocked','1');
   await post('cart/change.js',{id:line.key,quantity:0});
   await render(await getCart());return true;
  }
  if(line&&line.quantity!==1){await post('cart/change.js',{id:line.key,quantity:1});await render(await getCart());return true}
  if(!present){await render(cart);return true}
  return false;
 }

 async function sync(){
  if(running){rerun=true;return}
  running=true;
  try{
   let n=0;
   do{rerun=false;const changed=await pass();if(changed&&++n<3)rerun=true}while(rerun);
  }catch(e){/* fail safe: leave the cart untouched */}
  finally{running=false}
 }
 const schedule=()=>{clearTimeout(timer);timer=setTimeout(sync,300)};

 // Re-run after cart changes from any source (theme fetches, drawer buttons, quiz).
 const nativeFetch=window.fetch;
 window.fetch=function(input,init){
  const p=nativeFetch.apply(this,arguments);
  try{
   const url=typeof input==='string'?input:(input&&input.url)||'';
   const own=init&&init.headers&&(init.headers['X-BF-Rewards']||(init.headers.get&&init.headers.get('X-BF-Rewards')));
   if(!own&&CART_URL.test(url)&&String((init&&init.method)||(input&&input.method)||'GET').toUpperCase()==='POST'){
    p.then(r=>{if(r&&r.ok)schedule()},()=>{});
   }
  }catch(e){}
  return p;
 };
 document.addEventListener('bf:cart-priced',e=>{if(!e.detail||e.detail.source!=='rewards')schedule()});

 window.BFRewards={sync:schedule,isActive};
 if(isActive()||override())schedule();
})();
